import { render, staticRenderFns } from "./DeliveryPolicy.vue?vue&type=template&id=06bc727c&lang=pug&"
import script from "./DeliveryPolicy.vue?vue&type=script&lang=js&"
export * from "./DeliveryPolicy.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports